import { ImgID } from "../../image_loader/img_id.js";

// Which picture stands for which block, shared by the two places that show one:
// the progress panel counting toward the next block, and the overlay that hands
// it over. One table, so the bar and the celebration can never disagree.

/**
 * Confirmed against the art itself, not guessed from file names —
 * `goal_blue_box` is the METAL block despite reading like a stone one.
 *
 * Stone and brick are rendered straight from the game's block assets: the
 * authored mesh with its own textures under the game's lights, so they are the
 * blocks the player meets rather than a drawing of them. See
 * tools/goal_icon_render.ts.
 *
 * The starter blocks — plywood, plywood2, the cone — are absent because they
 * are never announced; they arrive in the first levels, before "new block"
 * means anything. Plastic IS here: it names the plastic cube, a real unlock.
 */
const GOAL_ICON_BY_MATERIAL: Record<string, ImgID> = {
  brick: ImgID.UI_GoalBrickBox,
  glass: ImgID.UI_GoalCherryJar,
  jar: ImgID.UI_GoalCherryJar,
  stone: ImgID.UI_GoalStoneBox,
  column: ImgID.UI_GoalColumnBox,
  rotating_table: ImgID.UI_GoalRotatingTable,
  side_to_side_table: ImgID.UI_GoalRightLeftTable,
  up_and_down_table: ImgID.UI_GoalTopBottomTable,
  tilted_table: ImgID.UI_GoalTiltingTable,
  fan: ImgID.UI_GoalFanBarrier,
  hammer: ImgID.UI_GoalHammerBarrier,
  ice: ImgID.UI_GoalIceCube,
  iron: ImgID.UI_GoalBlueBox,
  metal: ImgID.UI_GoalBlueBox,
  watermelon: ImgID.UI_GoalWatermelonBlock,
  tree: ImgID.UI_GoalWoodLog,
  wood: ImgID.UI_GoalWoodLog,
  plastic: ImgID.UI_GoalPlasticBoxRed,
};

/**
 * The icon for a set of unlock labels, falling back to the generic star box.
 *
 * The label carries a size suffix — "glass 1×2" — because the generator counts
 * a taller version of a block as its own unlock. The picture is of the
 * material, so the suffix is dropped.
 */
export function goalIconFor( unlocks: string[] | undefined ): ImgID
{
  for ( const label of unlocks ?? [] )
  {
    const material = String( label ).trim().split( " " )[0].toLowerCase();
    const icon = GOAL_ICON_BY_MATERIAL[material];
    if ( icon !== undefined )
      return icon;
  }
  return ImgID.UI_ResultStarBoxGoal;
}
